import PersistentDrawerLeft from "../../components/NewDrawer";
import DataGridWithSearch from "../../components/DataGridWithSearch";
import React, {useEffect, useState} from "react";
import {determineAddress, orderStatusMap} from "../../utils/utils";
import Loading from "../../components/Loading";
import useCallDataApi from "../../hooks/data";

const Clients = () => {
    const [clients, setClients] = useState([])
    const [loading, setLoading] = useState(true)
    const {getData} = useCallDataApi('users')

    const columns = [
        // {
        //     field: "manage",
        //     headerName: "Kezelés",
        //     sortable: false,
        //     type: "actions",
        //     getActions: (params) => [
        //         <GridActionsCellItem
        //             icon={<AvTimerIcon/>}
        //             onClick={() => {
        //                 setCurrent(params.row["id"])
        //                 toggleDeliveryPeriodDialog(true)
        //             }}
        //             label="Kiszállítási idő beállítása"
        //             showInMenu={true}
        //         />
        //     ],
        // },
        {field: "first_name", headerName: "Keresztnév", width: 150},
        {field: "last_name", headerName: "Vezetéknév", width: 150},
        {field: "email", headerName: "Email", width: 150},
        {field: "phone", headerName: "Telefonszám", width: 150},
    ]

    useEffect(() => {
        setLoading(true)
        getData('get_clients')
            .then(c => {
                setClients(c)
            })
            .finally(() => setLoading(false))
    }, [])

    return <div style={{height: "100vh"}}>
        <PersistentDrawerLeft title='Ügyfelek'>
            <DataGridWithSearch name='clients' rows={clients} columns={columns}/>

        </PersistentDrawerLeft>
        <Loading isLoading={loading}/>
    </div>
}

export default Clients